export default {
  admin: 'Administrateur',
  password: {
    enterNewPassword: 'Entrez un nouveau mot de passe',
    reenterNewPassword: 'Saisissez à nouveau le nouveau mot de passe',
    updatePassword: 'Mettre à jour le mot de passe',
    setPassword: 'Définir le mot de passe',
    min8CharacterMessage: 'Le mot de passe doit comporter au moins 8 caractères',
    passwordSentMessage: 'Le mot de passe a été envoyé à {userName} par e-mail.',
    generateNewPassword: 'Générer un nouveau mot de passe',
    assignPasswordMessage:
      'Attribuez un mot de passe à l’utilisateur. L’utilisateur devra changer ce mot de passe lors de sa prochaine connexion.',
    generateSecurePassword: 'Générer un mot de passe sécurisé',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    passwordHistory: 'Historique des mots de passe',
    passwordUpdatedLog: 'Mot de passe mis à jour par {userName} le {date}.',
    forgotPasswordLog: 'Demande de mot de passe oublié envoyée par {userName} le {date}.',
  },
};
